import { Users } from 'lucide-react';
import { UserMenu } from '@/components/UserMenu.js';

const CLUBS_URL =
  import.meta.env.VITE_HACKCLUBS_URL ||
  (import.meta.env.DEV ? 'http://localhost:5175' : 'https://clubs.hack.net.br');

function ClubsLink({ compact }: { compact?: boolean }) {
  return (
    <a
      href={CLUBS_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: compact ? 0 : 8,
        padding: compact ? 8 : '8px 12px',
        borderRadius: 8,
        border: '1px solid var(--border)',
        background: 'var(--bg3)',
        color: 'var(--text2)',
        textDecoration: 'none',
        fontSize: 12,
        fontWeight: 500,
        flexShrink: 0,
      }}
    >
      <Users size={16} strokeWidth={1.5} className="cor-marca" />
      {!compact && 'Hack Clubs!'}
    </a>
  );
}

type AppTopBarProps = {
  showConfig?: boolean;
  compact?: boolean;
};

export function AppTopBarActions({ showConfig, compact }: AppTopBarProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
      <ClubsLink compact={compact} />
      <UserMenu showConfig={showConfig} />
    </div>
  );
}

export function AppTopBar({ showConfig }: { showConfig?: boolean }) {
  return (
    <>
      <header
        className="fixed top-0 right-0 left-0 z-50 flex h-14 items-center justify-end gap-3 border-b px-4 md:hidden"
        style={{ background: 'var(--bg2)', borderColor: 'var(--border)' }}
      >
        <AppTopBarActions showConfig={showConfig} compact />
      </header>

      <header
        className="sticky top-0 z-40 hidden h-14 items-center justify-end gap-3 border-b px-6 md:flex"
        style={{ background: 'var(--bg2)', borderColor: 'var(--border)', flexShrink: 0 }}
      >
        <AppTopBarActions showConfig={showConfig} />
      </header>
    </>
  );
}
